import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SmallOrderTeamComponent } from './small-order-team.component';
import { DxDataGridModule, DxAutocompleteModule, DxCheckBoxModule} from 'devextreme-angular';
import { I18nModule } from "app/shared/i18n/i18n.module";
import { MaterialModule } from 'app/material.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SmallOrderTeamRoutingModule } from './small-order-team-routing.module';
import { OrgChartModule } from 'app/components/org-chart/org-chart.module';

@NgModule({
  imports: [
    CommonModule,
    DxDataGridModule,
    I18nModule,
    MaterialModule,
    FormsModule,
    NgxSpinnerModule,
    SmallOrderTeamRoutingModule,
    DxAutocompleteModule,
    DxCheckBoxModule,
    OrgChartModule
  ],
  declarations: [
    SmallOrderTeamComponent
  ]
})
export class SmallOrderTeamModule { }
